import { MODE_INFO, type Mode } from "../content/modes";
import "./SetDots.css";

interface Props {
  dots: { mode: Mode; held: boolean }[];
  /** Makes each dot a button, e.g. to pick that strand on Home. */
  onPick?: ((mode: Mode) => void) | undefined;
  className?: string;
}

/** One dot per strand in the set: filled when that strand holds the card. */
export function SetDots({ dots, onPick, className }: Props) {
  return (
    <span className={["set-dots", className].filter(Boolean).join(" ")}>
      {dots.map(({ mode, held }) => {
        const label = `${MODE_INFO[mode].label}: ${held ? "done" : "not yet"}`;
        const style = { "--dot": MODE_INFO[mode].colour } as React.CSSProperties;
        const cls = "set-dot display" + (held ? " held" : "");
        return onPick ? (
          <button
            key={mode}
            type="button"
            className={cls}
            style={style}
            aria-label={label}
            onClick={() => onPick(mode)}
          >
            {MODE_INFO[mode].sym}
          </button>
        ) : (
          <span key={mode} className={cls} style={style} role="img" aria-label={label}>
            {MODE_INFO[mode].sym}
          </span>
        );
      })}
    </span>
  );
}
